import React, { Component } from 'react';
import debounce from 'lodash/debounce';

import css from './forms.css';
import { teal500 } from '../../colors';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';

class SocialMedium extends Component {
  constructor(props) {
    super(props);
    this.formAttributes = {
      socialMediumId: '',
      userName: '',
      viewerCount: 0,
    };
    this.state = { socialMediumId: '' };
  }

  handleSelectSocialMedium = (e, i, id) => {
    e.preventDefault();
    this.setState({ socialMediumId: id });
    this.formAttributes.socialMediumId = id;
    this.props.updateForm(this.formAttributes);
    this.props.addItem();
  };

  handleInputChange = (e, value) => {
    // Update internal form attributes
    this.formAttributes.userName = value;

    // Update parent form attributes
    this.props.updateForm(this.formAttributes);
  };

  handleViewerCountChange = (e, value) => {
    // Update internal form attributes
    this.formAttributes.viewerCount = value;

    // Update parent form attributes
    this.props.updateForm(this.formAttributes);
  };

  render() {
    return (
      <div className={css.root}>
        <section>
          <SelectField
            value={this.state.socialMediumId}
            hintText="Select Social Media."
            onChange={this.handleSelectSocialMedium}
            style={{ margin: '0 10px' }}
          >
            {this.props.result.map(socialMediumId =>
              <MenuItem
                key={this.props.socialMedia.get(`${socialMediumId}`).get('slug')}
                value={this.props.socialMedia.get(`${socialMediumId}`).get('id')}
                primaryText={this.props.socialMedia.get(`${socialMediumId}`).get('name')}
              />
            )}
          </SelectField>
          <TextField
            floatingLabelText="Username"
            onChange={debounce(this.handleInputChange, 500)}
            fullWidth={true}
            className={css.textField}
          />
          <TextField
            floatingLabelText="Viewer Count"
            onChange={debounce(this.handleViewerCountChange, 500)}
            fullWidth={true}
            className={css.textField}
          />
          <IconButton
            onTouchTap={this.props.removeItem.bind(this, this.props.id)}
          >
            <NavigationClose />
          </IconButton>
        </section>
      </div>
    );
  }
};

export default SocialMedium;



/** WEBPACK FOOTER **
 ** ./components/forms/SocialMedium.js
 **/